module.exports = __webpack_public_path__ + "media/he.0f5e440c.wav";